import { useEffect, useState } from 'react'
import {useForm, useFieldArray } from'react-hook-form'
import Button from '../../components/button'
import DropDownListselect from '../../components/dropdown'
import Modal from '../../components/modal'
import { DropDown } from '../../components/selectTable/myDropDown'
import CertificationForm from './certificationForm'
import Styles from "./styles.module.scss";
import { Icon } from '@iconify/react';
import Headline5 from "../../components/headings/Headline5";
import {submitDetails} from './services';
import { useNavigate } from "react-router-dom";
import mixpanelData from '../../utils/mixpanel'
const { v4: uuidv4 } = require("uuid");
export default function Test(props:any) {

  const { register, control, handleSubmit, reset, watch } = useForm({
    defaultValues: {
      skills:props.defaultValues
    }
  });
      const { fields, append, remove } = useFieldArray({
          control,
          name:'skills'
      })
      const navigate = useNavigate()
  const [data, setData] = useState<any>()
  const [updatedData, setUpdatedData] = useState<any>([]);
  const [errorSkillsData, setErrorSkillsData] = useState<any>([]);
  const [errorCertificateData, setErrorCertificateData] = useState<any>([]);
  const [errorNoteData, setErrorNoteData] = useState<any>([]);
  const [showValidationMessage, setShowValidationMessage] = useState<any>(false);
    useEffect(() => {
      setData(props.defaultValues)
      const certificatedata: { skills: any; certificationType: any; certificationId: any; key: any }[]=[];
      props.defaultValues && props.defaultValues.map((newdata:any,index:any)=>{
        const n={skills:newdata.skills,certificationType:newdata.certificationType,certificationId:newdata.certificationId,key:index};
        certificatedata.push(n);
       
        
      });
      setUpdatedData(certificatedata);
     
      
    }, [props])

    const userloginId = localStorage.getItem("loginId");

  
 

    const onSubmit = (value: any) => {
      setShowValidationMessage(true);
   if(errorSkillsData.length==0 && errorCertificateData.length==0 && errorNoteData.length==0)
   {
const certificationpayload=updatedData.map(function(item:any) { 
  delete item.key; 
  return item; 
});

      var payload={
        loginId : props.loginId,
        userLoginId:userloginId,
        profileMetadata:{"ellowScreeningCertifications":certificationpayload
        }
        };
     
      submitDetails(payload).then((response: any) => {
        if (response && response.status === 1) {
          props.getTableValues();
          props.onClose();
          mixpanelData('TG-Certification updated', {
            'source': 'Recruiter updates certification',
            'distinct_id': localStorage.getItem('Email'),
            'certification type': certificationpayload && certificationpayload.length > 0 && certificationpayload.map((item: any) => item.certificationType).toString(),
            'skill': certificationpayload && certificationpayload.length > 0 && certificationpayload.map((item: any) => item.skills && item.skills.name),
            'Recruiter email': localStorage.getItem('Email'),
            'Candidate email': response && response.data[0] && response.data[0].profile_metadata && response.data[0].profile_metadata.email,
            'Candidate name': response && response.data[0] && response.data[0].profile_metadata && response.data[0].profile_metadata.firstName,
            'Candidate login id': props.loginId,
          })
          certificationpayload && certificationpayload.length > 0 && certificationpayload.map((item: any) => {
          mixpanelData('New TG - Certification details updated', {
            'Source': 'Recruiter updates certification from listing',
            'distinct_id': localStorage.getItem('Email'),
            'certification type': item.certificationType,
            'Certification skill': item.skills && item.skills.name,
            'Recruiter email': localStorage.getItem('Email'),
            'Candidate email': response && response.data[0] && response.data[0].profile_metadata && response.data[0].profile_metadata.email,
            'Candidate name':`${ response && response.data[0] && response.data[0].profile_metadata && response.data[0].profile_metadata.firstName} ${response && response.data[0] && response.data[0].profile_metadata && response.data[0].profile_metadata.lastName}`,
            'Candidate loginid': props.loginId,
            'Overall rating': 'NA',
            'Subskills': 'NA',
            'Percentile': 'NA'
          })

          })
         }
       });   
      }
    }
    const onClick = (e: any) => {
        e.preventDefault()
        append({})
    }

    const onChange = (newData:any) => {
      // setUpdatedData(data.push(newData))
     
    }

    return (
        <Modal title={" "} size="medium" onClose={props.onClose}>
            <form>
            <Headline5>Certified</Headline5>
            <button onClick={(e:any) => onClick(e)} className={Styles.addWorkHistory}> <Icon icon="fluent:add-circle-28-regular" />Add New</button> 
       
           {fields.map((item , index) => {
                return (
                  
                        <CertificationForm 
                        showValidationMessage={showValidationMessage}
                        errorNoteData={errorNoteData}
                        setErrorNoteData={setErrorNoteData}
                        keyidd={uuidv4()} errorSkillsData={errorSkillsData} setErrorSkillsData={setErrorSkillsData} errorCertificateData={errorCertificateData}  setErrorCertificateData={setErrorCertificateData}  loginId={props.loginId}    updatedData={updatedData} setUpdatedData={setUpdatedData} key={item.id}  defaultValues={item} removeId={index} remove={remove}   />
                      
                    
               )
            })}
            <div>
               <div className="popupAction">
                 <Button variant="secondary" onClick={props.onClose}>
                 Close
                 </Button>
                 <Button variant="primary" onClick={handleSubmit(onSubmit)}>
                 Save
                </Button>
               </div>
            </div>
            </form>
            </Modal>
    )
}